/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Bo as Bo,
  rec_Ir as Ir,
  rec_J0 as J0,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ti as Ti,
  rec_Ur as Ur,
  rec_qi as qi,
  rec_t3 as t3,
} from "../../runtime/index.jsx";
export function ImportacionNisira(e) {
  let t = (0, ReactCompiler.c)(30),
    {
      nisira: n,
      leidaEn: r,
      vacio: i,
      importando: a,
      onImportar: o,
      onCargaInicial: s,
      onNuevo: c,
      cifras: l,
    } = e,
    u = (0, React.useRef)(null),
    f = (0, React.useRef)(null),
    p = n?.datosAl ?? null,
    m = J0(p, r),
    h;
  t[0] !== p || t[1] !== m || t[2] !== n
    ? ((h = n ? (
        <JSXRuntime.Fragment
          children={[
            <p
              className={`font-medium text-(--text-h)`}
              children={[
                `NISIRA: `,
                t3(n.personas),
                ` personas`,
                p && (
                  <JSXRuntime.Fragment
                    children={[
                      ` · datos al `,
                      new Date(p).toLocaleDateString(`es-PE`),
                    ]}
                  />
                ),
              ]}
            />,
            <p
              className={`text-xs text-(--text)`}
              children={[
                `Importado el `,
                new Date(n.importadaEn).toLocaleString(`es-PE`),
                n.importadaPor ? ` por ${n.importadaPor}` : ``,
              ]}
            />,
            m !== null && m > 7 && (
              <p
                className={`mt-1 flex items-center gap-1 text-xs text-(--warning-texto)`}
                children={[
                  (0, JSXRuntime.jsx)(qi, {
                    className: `h-3.5 w-3.5 shrink-0`,
                  }),
                  `Los datos tienen `,
                  m,
                  ` días. Actualizá la consulta en Excel antes de importar.`,
                ]}
              />
            ),
          ]}
        />
      ) : (
        <p
          className={`text-(--text)`}
          children={`Todavía no se importó NISIRA.`}
        />
      )),
      (t[0] = p),
      (t[1] = m),
      (t[2] = n),
      (t[3] = h))
    : (h = t[3]);
  let _;
  t[4] === l
    ? (_ = t[5])
    : ((_ = l && (
        <p
          className={`mt-2 hidden flex-wrap gap-x-4 gap-y-1 text-xs text-(--text) sm:flex`}
          children={[
            <span
              children={[
                <b
                  className={`text-sm text-(--text-h)`}
                  children={t3(l.puestos)}
                />,
                ` puestos`,
              ]}
            />,
            <span
              children={[
                <b
                  className={`text-sm text-(--text-h)`}
                  children={t3(l.vacantes)}
                />,
                ` vacantes`,
              ]}
            />,
            <span
              children={[
                <b
                  className={`text-sm ${l.porRevisar ? `text-(--warning-texto)` : `text-(--text-h)`}`}
                  children={t3(l.porRevisar)}
                />,
                ` por revisar`,
              ]}
            />,
            <span
              children={[
                <b
                  className={`text-sm ${l.cargoDistinto ? `text-(--warning-texto)` : `text-(--text-h)`}`}
                  children={t3(l.cargoDistinto)}
                />,
                ` con el cargo distinto a NISIRA`,
              ]}
            />,
          ]}
        />
      )),
      (t[4] = l),
      (t[5] = _));
  let v;
  t[6] !== h || t[7] !== _
    ? ((v = <div className={`min-w-0 text-sm`} children={[h, _]} />),
      (t[6] = h),
      (t[7] = _),
      (t[8] = v))
    : (v = t[8]);
  let y;
  t[9] === o
    ? (y = t[10])
    : ((y = (
        <input
          ref={u}
          type={`file`}
          accept={`.xlsx`}
          aria-label={`Archivo de NISIRA`}
          className={`sr-only`}
          onChange={(e) => {
            let t = e.target.files?.[0];
            ((e.target.value = ``), t && o(t));
          }}
        />
      )),
      (t[9] = o),
      (t[10] = y));
  let b;
  t[11] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((b = () => u.current?.click()), (t[11] = b))
    : (b = t[11]);
  let x;
  t[12] === a
    ? (x = t[13])
    : ((x = (
        <AccionAsync
          variante={`secundario`}
          className={`min-h-11`}
          icono={Ir}
          ocupado={a}
          textoOcupado={`Importando…`}
          onClick={b}
          children={`Importar NISIRA`}
        />
      )),
      (t[12] = a),
      (t[13] = x));
  let S;
  t[14] === s
    ? (S = t[15])
    : ((S = (
        <input
          ref={f}
          type={`file`}
          accept={`.xlsx,.xls`}
          aria-label={`Excel del organigrama`}
          className={`sr-only`}
          onChange={(e) => {
            let t = e.target.files?.[0];
            ((e.target.value = ``), t && s(t));
          }}
        />
      )),
      (t[14] = s),
      (t[15] = S));
  let C;
  t[16] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((C = () => f.current?.click()), (t[16] = C))
    : (C = t[16]);
  let w = i ? `Carga inicial desde Excel` : `Reemplazar desde Excel`,
    T;
  t[17] === w
    ? (T = t[18])
    : ((T = (
        <AccionAsync
          variante={`secundario`}
          className={`min-h-11`}
          icono={Ur}
          onClick={C}
          children={w}
        />
      )),
      (t[17] = w),
      (t[18] = T));
  let E;
  t[19] === c
    ? (E = t[20])
    : ((E = (
        <AccionAsync
          className={`min-h-11`}
          icono={Ti}
          onClick={c}
          children={`Nuevo puesto`}
        />
      )),
      (t[19] = c),
      (t[20] = E));
  let D;
  t[21] !== T || t[22] !== E || t[23] !== y || t[24] !== x || t[25] !== S
    ? ((D = (
        <div className={`flex flex-wrap gap-2`} children={[y, x, S, T, E]} />
      )),
      (t[21] = T),
      (t[22] = E),
      (t[23] = y),
      (t[24] = x),
      (t[25] = S),
      (t[26] = D))
    : (D = t[26]);
  let O;
  return (
    t[27] !== D || t[28] !== v
      ? ((O = (
          <div
            className={`${Bo} flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between`}
            children={[v, D]}
          />
        )),
        (t[27] = D),
        (t[28] = v),
        (t[29] = O))
      : (O = t[29]),
    O
  );
}
